function getCookieValue(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    if (!match)
        return null;
    return decodeURIComponent(match[2]);
}
export class RegistrationWallsQualifier {
    constructor() {
        this.key = "RegistrationWalls";
    }
    process() {
        const cookieValue = getCookieValue("IsActCr");
        if (!cookieValue) {
            return "false";
        }
        try {
            const parsed = JSON.parse(cookieValue);
            return parsed ? "true" : "false";
        }
        catch (_a) {
            return "false";
        }
    }
}
